import { Box, Grid2, Typography } from '@mui/material';
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const Footer: React.FC = () => {
  const { isLoggedIn, user } = useAuth();

  return !user && !isLoggedIn ? null : (
    <Grid2
      container
      justifyContent='center'
      alignItems='center'
      sx={{ py: 2, px: 2 }}
      direction='column'
    >
      <Grid2>
        <Typography
          className='ms-body2'
          color='textSecondary'
          component='div'
          sx={{ textAlign: 'center' }}
        >
          © {new Date().getFullYear()}{' '}
          <Box
            component='a'
            href='https://imarketsmart.com'
            target='_blank'
            rel='noopener noreferrer'
            sx={{
              color: 'primary.main',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            MarketSmart
          </Box>
          , All Rights Reserved
        </Typography>
      </Grid2>
    </Grid2>
  );
};

export default Footer;
